<template>

</template>

<script setup>
import {useQuasar} from "quasar";
import {useRouter, useRoute} from "vue-router";
import {useStore} from "vuex";
import {event} from "vue-gtag";
import { inject } from 'vue'

const quasar = useQuasar();
const router = useRouter();
const route = useRoute();
const store = useStore();
const axios = inject('axios');

axios
    .patch('auth/logout', {allDevices: route.query.allDevices === 'true'})
    .then(async () => {
      store.commit('logout');
      quasar.cookies.remove('_auth_token', {path: '/'});
      delete axios.defaults.headers.common['Authorization'];
      event('logout', {method: 'Google'});
      await router.push({name: 'home'});
    });
</script>

<style scoped>

</style>
